import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Y si no estoy shadowbanned?',
  answer: 'Perfecto: el kit también sirve para confirmar si es fatiga/retención/competencia y dejar de perseguir fantasmas.'
}, {
  question: '¿Me conviene abrir cuenta nueva?',
  answer: 'El kit te dice cuándo considerarlo (sin impulsos) y cómo evitar perder tu base por pánico.'
}, {
  question: '¿Esto sirve para TikTok e Instagram?',
  answer: 'Sí: el enfoque es por síntomas + acciones seguras, no por un “hack” de una sola app.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24" data-id="element-61">
      <div className="mx-auto max-w-3xl px-6" data-id="element-62">
        <h2 className="mb-12 text-center text-2xl font-bold text-white" data-id="element-63">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-64">
          {faqs.map((faq, index) => <div key={index} className="overflow-hidden rounded-lg border border-white/10 bg-[#141414]" data-id="element-65">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between p-6 text-left font-medium text-white transition-colors hover:bg-white/5" data-id="element-66">
                {faq.question}
                <ChevronDown className={`h-5 w-5 text-gray-500 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-67" />
              </button>
              <AnimatePresence data-id="element-68">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-69">
                    <div className="border-t border-white/5 px-6 pb-6 pt-2 text-gray-400" data-id="element-70">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}